import { render, staticRenderFns } from "./SearchUsergroups.vue?vue&type=template&id=57b763ae"
import script from "./SearchUsergroups.vue?vue&type=script&lang=js"
export * from "./SearchUsergroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports